import { BAR } from 'src/components/Charts/types';
import largestRemainder from '../../../util/numbers/largestRemainder';

/**
 * Função que formata os dados dos resultados percentuais para 1 casa decimal
 * @param data dados do gráfico simples
 * @param percentage porcentagem a qual a soma de todas as outrasa devem totalizar
 * @param chartType tipo do gráfico
 */
export function formatSimpleChartData(data = []) {
  if (data === null) {
    return;
  }

  const totalPercentage = Math.round(
    data
      .map((item) => item.resultado_percentual)
      .reduce((reduced, next) => reduced + next, 0),
  );

  // Mapeia o resultado percentual para um array, para que o largest remainder possa
  // ser executado
  const array = data.map((value) => value.resultado_percentual);

  // Formata os valores e garante que a soma deles será igual a percentage
  const resultado_percentual = largestRemainder(totalPercentage, array, 2);

  // Percorre os dados setando os valores formatados
  return data.map((value, index) => ({ ...value, resultado_percentual: resultado_percentual[index] }));
  
}
